// Brand wire schema — shared across admin, asset, asset-group, report,
// and resolve responses so every endpoint that surfaces a brand emits
// the same row shape. Architecture rationale in ADR-0033 §Consequence 1
// (per-brand logos, single wire row).
import { z } from "zod";
export const brandSummarySchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    logoUrl: z.string().url().nullable(),
    logoUpdatedAt: z.string().datetime().nullable(),
    // Horizontal (wide) logo for the owner-home header (canal único fase 1,
    // ADR-0140 §5). Lives at brands.config.logoWideUrl, uploaded by the
    // platform admin only in fase 1 — the inmobiliaria gets its own
    // Configuración surface in fase 2. Unlike `logoUrl` it is NOT padded
    // to square; the client validates a landscape aspect ratio instead.
    // Null everywhere a brand hasn't opted in — consumers fall back to the
    // square `logoUrl` isotipo, so brands without it see zero change.
    // `.default(null)` (not just `.nullable()`): a payload from a core-api
    // that predates the key (deploy skew) parses as null instead of failing.
    logoWideUrl: z.string().url().nullable().default(null),
});
// GET /internal/orgs/:organizationId/brand-count (ADR-0115) is retired —
// superseded by GET /internal/orgs/:organizationId/membership-policy
// (ADR-0119), a superset of this data. See ./membership-policy.js.
//# sourceMappingURL=brands.js.map